import {BaseStore} from "mam-core-react"
export default BaseStore